import './polyfills';
import { render } from 'preact';
import './styles.css';
import { App } from './app';
import { detectLocale, setLocale } from './i18n';
import { isEmbedded, listenParent } from './embed-bridge';

export type Theme = 'light' | 'dark' | 'auto';
export function applyTheme(theme: Theme): void {
  const root = document.documentElement;
  if (theme === 'auto') root.removeAttribute('data-theme');
  else root.setAttribute('data-theme', theme);
  try {
    localStorage.setItem('cv-theme', theme);
  } catch {
    /* storage unavailable */
  }
}

const params = new URLSearchParams(location.search);
const urlTheme = params.get('theme');
let stored: string | null = null;
try {
  stored = localStorage.getItem('cv-theme');
} catch {
  /* ignore */
}
const initialTheme = (urlTheme ?? stored ?? 'auto') as Theme;
applyTheme(['light', 'dark', 'auto'].includes(initialTheme) ? initialTheme : 'auto');

if (isEmbedded) {
  document.documentElement.setAttribute('data-embedded', 'true');
  listenParent({ onTheme: applyTheme, onLocale: (l) => void setLocale(l, true) });
}

// Load the detected language before first paint so non-English payers never see an English flash.
void setLocale(detectLocale()).finally(() => {
  render(<App />, document.getElementById('app')!);
});
